import { render, staticRenderFns } from "./TheNavigationBase.vue?vue&type=template&id=f21d2712"
import script from "./TheNavigationBase.vue?vue&type=script&lang=ts"
export * from "./TheNavigationBase.vue?vue&type=script&lang=ts"
import style0 from "./TheNavigationBase.vue?vue&type=style&index=0&id=f21d2712&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports